
import './BreadCrumb.scss';

const BreadCrumb = ({ title }) => {
    return (
        <div id='heroTitle' className="d-flex justify-around md:justify-between flex-col lg:flex-row lg:items-center">
            <hr className="lg:w-3/12" />
            <div className='mx-auto'>
                <span className="text-center">{title}</span>
            </div>
            <hr className="lg:w-3/12" />
        </div>
    );
};

export default BreadCrumb;